// Utilitarios da Adesao ao Plano na area do credor.

export const TERM_STATUS = {
  draft: { label: "Rascunho", color: "grey" },
  awaiting_signature: { label: "Aguardando assinatura", color: "orange darken-1" },
  submitted: { label: "Enviado — em validação", color: "blue" },
  in_review: { label: "Em análise pelo AJ", color: "blue" },
  approved: { label: "Adesão aprovada", color: "success" },
  rejected: { label: "Rejeitado", color: "error" },
  revoked: { label: "Revogado pelo AJ", color: "grey darken-2" },
  cancelled: { label: "Cancelado", color: "grey" },
};

export const CANCEL_REASONS = {
  replaced: "Substituído por um novo termo",
  template_superseded: "O termo foi atualizado: assine a nova versão",
  plan_superseded: "O plano foi atualizado: assine a nova versão",
  credit_changed: "O valor, a classe ou a moeda do seu crédito mudou: assine um novo termo",
};

export function errorMessage(error, fallback = "Não foi possível concluir a operação. Tente novamente.") {
  const content = error && error.response && error.response.data && error.response.data.content;
  if (content && content.error && content.error.message) return content.error.message;
  return fallback;
}

export function parseUtc(value) {
  if (!value) return null;
  const text = String(value);
  const date = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}/.test(text) ? new Date(`${text.replace(" ", "T")}Z`) : new Date(text);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function formatDateTime(value) {
  const date = parseUtc(value);
  return date ? date.toLocaleString("pt-BR", { timeZone: "America/Sao_Paulo", dateStyle: "short", timeStyle: "short" }) : "—";
}

export function formatMoney(amount, currency = 1) {
  const symbol = { 1: "R$", 2: "US$", 3: "€" }[Number(currency)] || "R$";
  return `${symbol} ${Number(amount || 0).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}
